import React from 'react';
import PlotlyChart from './PlotlyChart';

const GaugeChart = ({
  data,
  chartOptions
}) => {

  const { numberFunction, format = 'number', title = 'Gauge Chart', showLabels = true, bands = [
    { range: [85, 90], color: '#fbbf24' },
    { range: [90, 95], color: '#86efac' },
    { range: [95, 100], color: '#4ade80' }
  ] } = chartOptions || {};

  if (numberFunction) {
    var value = numberFunction(data[0])
  } else {
    var value = _.values(data[0])[0]
  }

  if (format === 'percentage') {
    value = (value * 100).toFixed(1)
  }

  const chartData = [{
    type: "indicator",
    mode: "gauge+number",
    value: value,
    number: {
      suffix: format === 'percentage' ? '%' : '',
      font: {
        size: 56,
        color: "#334155",
        family: "system-ui, -apple-system, sans-serif"
      }
    },
    gauge: {
      axis: {
        range: [85, 100],
        tickwidth: 0,
        tickcolor: "white",
        visible: showLabels,
        tickmode: "array",
        tickvals: [85, 90, 95, 100],
        ticktext: ['85%', '90%', '95%', '100%'],
        tickfont: {
          size: 16,
          color: "#64748b"
        }
      },
      bar: {
        color: "#cbd5e1",
        thickness: 0.15,
        line: { width: 0 }
      },
      bgcolor: "white",
      borderwidth: 0,
      bordercolor: "white",
      steps: bands.map(band => ({
        range: band.range,
        color: band.color,
        thickness: 0.85
      })),
      threshold: {
        line: { color: "white", width: 6 },
        thickness: 1,
        value: value
      }
    }
  }];

  const layout = {
    margin: { t: 80, r: 40, l: 40, b: 40 },
    paper_bgcolor: "#f8fafc",
    font: {
      family: "system-ui, -apple-system, sans-serif",
      color: "#334155"
    },
    title: {
      text: title,
      font: {
        size: 24,
        color: "#475569",
        family: "system-ui, -apple-system, sans-serif"
      },
      x: 0,
      xanchor: 'left',
      pad: { l: 20 }
    }
  };

  const config = {
    displayModeBar: false,
    responsive: true
  };

  return <PlotlyChart data={chartData} layout={layout} config={config} />;
};

export default GaugeChart;
